// removed by extract-text-webpack-plugin
module.exports = {"blog":"_2uuqsk8NXtnzCRWX9Om3j_0","blogItems":"_1fRuwSwg-8-x3XKYITGW9K_0","thumbnail":"_3tKwXf7FGn4trV6f99KhiY_0","item":"xltssfnLQ0Xa5xKTkyRJA_0","meta":"_1nj6wpwqyDdjZ0SZzZje0z_0","title":"cAXATEMEdomUgNyuIo1ib_0","excerpt":"_2w0hWXgYlDWDFbiFaDUIc_0"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"extract":true,"remove":true}!./~/vue-style-loader!./~/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-rewriter.js?id=data-v-63790e92!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Blog.vue
// module id = 59
// module chunks = 2